import { Button, Input } from "antd";
import { Link } from "react-router-dom";
import SearchIcon from "../../../assets/web/icons/SearchIcon";
import Container from "../../../components/web/Container";
import BannerContainer from "../../../components/web/common/BannerContainer";
import StoryCard from "../../../components/web/common/StoryCard";
import PublicLayout from "../../../layouts/PublicLayout";

export default function Stories() {
  return (
    <PublicLayout title="Stories | Sheba Business Portal">
      <BannerContainer>
        <div className="text-center text-4xl md:text-6xl font-bold text-textHeading">
          Our Journey of Success
        </div>

        <div className="max-w-[400px] mx-auto mt-10">
          <div className="flex items-stretch">
            <Input prefix={<SearchIcon />} className="rounded-r-none" />
            <Button className="bg-[#001652] !text-white rounded-l-none">
              Search
            </Button>
          </div>
        </div>
      </BannerContainer>
      <div className="pb-16">
        <Container>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {[...Array(9)].map((_, index) => (
              <Link to="details">
                <StoryCard key={index} />
              </Link>
            ))}
          </div>
        </Container>
      </div>
    </PublicLayout>
  );
}
